import type { MeResponse, OrganizationKind } from '@tvitvi/shared';

/**
 * HVA SLAGS HUS ER JEG I? (migrering 0081, vedtak 93.1.)
 *
 * ---------------------------------------------------------------------------------------------
 * Ett sted, fordi det nå er TRE menyer som spør: sidemenyen skjuler Booking og Festivaler i et
 * byrå og viser Artister, innstillingsmenyen skjuler scenetider og budvilkår, og oversikten
 * skjuler kortene som handler om en årgang. Den fjerde som trenger det skal ikke måtte finne ut
 * av `memberships.find(...)` på nytt.
 *
 * VERDIEN KOMMER FRA MEDLEMSKAPET og ikke fra et eget kall, så alt bytter form i det samme
 * øyeblikket man bytter organisasjon.
 *
 * `festival` SOM FALLBACK, og det er ikke en tilfeldig default: hvert hus som fantes før kolonnen
 * ble til er en festival, og en meny som forsvant mens svaret lastet ville blinket.
 */
export function organizationKindOf(me: MeResponse | null): OrganizationKind {
  if (me === null) return 'festival';
  return (
    me.memberships.find((entry) => entry.organizationId === me.activeOrganizationId)
      ?.organizationKind ??
    /* Gjestemodus (sak 232): organisasjonen som delte står i `guestOrganizations`, aldri i medlemskapene. */
    me.guestOrganizations.find((entry) => entry.organizationId === me.activeOrganizationId)
      ?.organizationKind ??
    'festival'
  );
}
